import PropTypes from "prop-types";
import React from "react";
import IconButton from "ui/IconButton";
import IconCross from "assets/svg/cross.svg";

const IconButtonCross = (props) => {
  return (
    <IconButton {...props}>
      <IconCross />
    </IconButton>
  );
};

IconButtonCross.propTypes = {
  onClick: PropTypes.func,
};

export default IconButtonCross;
